import React, { useCallback, useState } from 'react';
import { useVisualizationSettings, VisualizationType } from '../ForecastingContextProvider';
import { displayKey, formatNumber } from '../../leaflet/util/SummaryFormatting';
import Select from 'react-select';

export default function ForecastingVisualisationSettings() {
    const { visualizationType, updateVisualizationSetting } = useVisualizationSettings();

    const [isVisualisationSettingsVisible, setVisualisationSettingsVisibility] = useState(false);
    const toggleVisualisationSettingsVisibility = useCallback(() => {
        setVisualisationSettingsVisibility(!isVisualisationSettingsVisible);
    }, [isVisualisationSettingsVisible]);
    
    const defaultValue  = visualizationType;
    const defaultLabel: string = displayKey(defaultValue as VisualizationType);
    const selectOptions = ['numberOfScreens', 'potentialSpend', 'averageCpm', 'numberOfImpressions', 'numberOfAudienceImpressions']
        .map( (visualisationType): {label: string, value: VisualizationType} => { return {label: displayKey(visualisationType as VisualizationType), value: visualisationType  as VisualizationType}; });

    return (
        <div className='w-80 mt-4'>
            <button
                className='block text-sm font-semibold text-gray-600'
                onClick={toggleVisualisationSettingsVisibility}
            >
                {isVisualisationSettingsVisible ? '▼': '▶'} <span className='no-underline hover:underline'>Visualisation settings</span>
            </button>

            {
                isVisualisationSettingsVisible && <div className='mt-4 w-80'>
                    <label
                        htmlFor='diagramType'
                        className='block text-sm font-medium text-gray-700'
                    >
                        Visualisation data
                    </label>
                    <Select
                        key={'visualisationData'}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        isMulti={false}
                        name='visualisationData'
                        className='basic-multi-select'
                        classNamePrefix='select'
                        onChange={newValue => updateVisualizationSetting((newValue?.value ?? defaultValue) as VisualizationType)}
                        options={selectOptions}
                        defaultValue={{value: defaultValue, label: defaultLabel}}
                    />
                </div>
            }
        </div>
    );
}
